import * as React from "react"
import { Skeleton } from "@mui/material"
import { AmchartSeeker } from "@ui-seeker/core"

import { TitleWithPopover } from "@components"
import { useCatalogueAnalyzerNumPerRetailerChart } from "./@hooks"


const HEIGHT = 700

export default function CatalogueAnalyzerNumPerRetailerChart() {

    const { isLoading, data, title, seriesName } = useCatalogueAnalyzerNumPerRetailerChart()

	if (isLoading) return <Skeleton variant="rectangular" height={HEIGHT} />
	if (!data.length) return <></>
  
    return <AmchartSeeker
        data={data}
        title={<TitleWithPopover title={title} />}
        rootID="NumPerRetailer"
        series={[{
            name: seriesName,
            xField: 'value',
            yField: 'siteName',
            type: 'column',
            showLabel: false
        }]}
        chartProps={{
            numberFormat: `#.`,
            xAxis: {
                type: 'value',
            },
            yAxis: {
                type: 'category',
                categoryField: 'siteName',
                renderer: { minGridDistance: 15 }
            },
            legend: {
                hidden: true
            },
            scrollbarX: { hidden: true }
        }}
        sx={{ height: 450 }}
    />
}